import { LAST_12_MONTH, LAST_30_DAYS } from "./filters";
import Moment from "moment-timezone";
import { extendMoment } from "moment-range";

export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_FORMAT2 = "YYYY-MM-DD";
export const DATE_TIME_FILTERS_FORMAT = "YYYY-MM-DD HH:mm";
export const REPORT_NAME_DATE_FORMAT = "YYYYMMDD";

export const thisWeek = () => {
  return [
    moment().startOf("isoweek").format(DATE_TIME_FILTERS_FORMAT),
    moment().endOf("isoweek").format(DATE_TIME_FILTERS_FORMAT)
  ];
};

const moment = extendMoment(Moment);

export const dateRange = (fromDate, toDate) => {
  return [fromDate.format(DATE_FORMAT), toDate.format(DATE_FORMAT)];
};

export const setDateRange = (fromDate, toDate) => {
  switch (fromDate) {
    case LAST_12_MONTH:
      return thisWeek();
    case LAST_30_DAYS:
      return [];
    default:
      return dateRange(fromDate, toDate);
  }
};
